(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('systemTasksDao', ["http", "brandInfo", "path", "$q", function (http, brandInfo, path, $q) {
        var configForAPI = { headers: { customer_domain: brandInfo.getCustomerDomain() } };
        return {
            list: function () {
                return http.get('/api/v1/task', configForAPI);
            },
            list_test: function () {
                return http.get(path('gui-v2').ctrl('system-tasks').json('list').path);
            },
            task: function (taskId) {
                return http.get('/api/v1/task/' + taskId, configForAPI);
            },
            task_test: function (taskId) {
                return http.get(path('gui-v2').ctrl('system-tasks').json('task').path);
            },
            add: function (taskType, module, owner) {
                /*
            * @param: task - required
            * @param: module - task's module (ex: office365_emails)
            * @param: owner - required, current logged in user's email to create the task
            *
            * */
                return http.post('/api/v1/task', configForAPI).body({
                    task_type: taskType,
                    module: module,
                    owner: owner
                }).run();
            },
            edit: function (taskId, task) {
                return http.put('/api/v1/task/' + taskId, configForAPI).body(task).run();
            },
            remove: function (taskId) {
                return http.delete('/api/v1/task/' + taskId, configForAPI).run();
            },
            editAction: function (taskId, actionId, action) {
                return http.post('/api/v1/task/' + taskId + '/action/' + actionId + '/update_action', configForAPI).body(action).run();
            },
            onboardingTask: function (module) {
                return http.get('/api/v1/task/module/' + module, configForAPI);
            }
        };
    }]);
}());